import React, { useState, useEffect } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useNavigate } from "react-router-dom";
import Arrow from "../../images/arrow.svg";
import "./Active.css";
import Colors from "../../images/color.svg";
import Diff from "../../images/dif.svg";
import Razm from "../../images/razm.svg";
import Search from "../../images/adminSearch.svg";
import Download from '../../images/download.svg'
import api from "../../utils/Api";
function Active() {
  const [cards, setCards] = useState(null);
  const [currentImage, setCurrentImage] = useState("original");
  const navigate = useNavigate();
  useEffect(() => {
    setCards(JSON.parse(localStorage.getItem("active")));
  }, []);

  const toggleImage = () => {
    setCurrentImage((prev) =>
      prev === "original" ? "colorsOriginal" : "original"
    );
  };

  return (
    <div className="Active">
      {cards ? (
        <div className="active__card full-screen">
          <TransformWrapper
            initialScale={1} // Начальный масштаб 1
            minScale={0.5} // Можно уменьшить (если не нужно — удали эту строку)
            maxScale={5} // Позволяем увеличить до 5 раз
            centerOnInit={true} // Центрируем изображение при загрузке
          >
            <TransformComponent>
              <img
                alt="img"
                src={`https://vandalvisionteam-vandalvision-servernew-8cf3.twc1.net/uploads/${
                  cards.article
                }/${
                  currentImage === "original"
                    ? cards.images.original
                    : cards.images.colorsOriginal
                }`}
                className="zoomable-image"
              />
            </TransformComponent>
          </TransformWrapper>

          <div className="active__card__control">
            <button
              className="arrow active__card__control__left"
              onClick={toggleImage}
            >
              <img alt="icon" src={Arrow} />
            </button>
            <button
              className="arrow active__card__control__right"
              onClick={toggleImage}
            >
              <img alt="icon" src={Arrow} />
            </button>
          </div>
          <div className="active__card__info">
            <p className="active__card__info__title">{cards.article}</p>
            <div className="active__card__info__con">
              <p className="active__card__info__con__con__info">
                <img alt="razm" src={Razm} />
                Размер: {cards.size}
              </p>
              <p className="active__card__info__con__con__info">
                <img alt="color" src={Colors} />
                Цветов: {cards.colors}
              </p>
              <p className="active__card__info__con__con__info">
                <img alt="diff" src={Diff} />
                Сложность:{" "}
                <div
                  className={`${
                    cards.difficulty === "easy" && "AdminDiffGreen"
                  } ${cards.difficulty === "normal" && "AdminDiffOrange"} ${
                    cards.difficulty === "hard" && "AdminDiffRed"
                  }  active__card__info__con__dif`}
                >
                  {cards.difficulty === "easy" && "Легко"}{" "}
                  {cards.difficulty === "normal" && "Средняя"}{" "}
                  {cards.difficulty === "hard" && "Сложно"}
                </div>
              </p>
            </div>
            <button onClick={() => {
              localStorage.removeItem("active")
              navigate('/')
            }} className="active__card__info__btn">
              <img alt="img" src={Search} />
              Вернуться к поиску
            </button>
          </div>
          <button
  onClick={() => {
    api.download(cards.id, currentImage).then((res) => {
      const blob = new Blob([res], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `image-${cards.id}-${currentImage}.png`); // Имя файла
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch((err) => {
      console.error("Ошибка при скачивании файла:", err);
    });
  }}
  className="active__card__btn"
>
  <img alt="img" src={Download} />Скачать
</button>


        </div>
      ) : (
        <p>Загрузка...</p>
      )}
    </div>
  );
}

export default Active;
